/*
 * Copyright (c) 2025. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import type { Layer, Map as LeafletMap } from 'leaflet';
import { useEffect } from 'react';

function useMapLayer(map: LeafletMap, layer: Layer | null | undefined, enabled = Boolean(layer)) {
  useEffect(() => {
    if (layer && enabled) {
      layer.addTo(map);
      return () => {
        layer.remove();
      };
    }
  }, [map, layer, enabled]);
}

export default useMapLayer;
